const DEFAULTVALUE = 0;

export default DEFAULTVALUE;

export const CLASSIFICATIONCODE = 'EQUIPMENT';
export const APPROPRIATIONCODE = 'APPROPRIATION';
export const CONTRACTTYPE = 'CONTRACT_TYPE';
export const SCHOOLLEVELCODE = 'SCHOOL_LEVEL';
